import { Component, ViewChild } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { PaginationComponent } from '../../home/common/pagination/pagination.component';
import { ActivatedRoute } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { WarehouseService } from 'src/app/home/services/warehouse.service';
import { MasterService } from 'src/app/home/services/master.service';
import { timestampFormat } from '../../../app/config/moment';

@Component({
  selector: 'app-transit-detail',
  standalone: true,
  imports: [CommonModule, PaginationComponent, FormsModule],
  templateUrl: './transit-detail.component.html',
  styleUrls: ['./transit-detail.component.scss', '../../app.component.scss']
})
export class TransitDetailComponent {
  @ViewChild(PaginationComponent) paginationView: PaginationComponent;
  
  public timestampFormat = timestampFormat;

  public totalPages: number = 10;
  public currentPage: number = 1;

  public warehouseId: string = "4";
  public warehouses: any = [];
  public shipmentId: string = "";
  public summaryDetails: any = [];
  public summaryProducts: any = [];

  public isSummaryProducts: boolean = false;

  public searchInput: string = "";
  public encodedSearchInput: string = "";

  public isSearch = false;

  public isFilter = false;
  public isFilterResult = true;
  
  public expirySortValue:string = "";
  public orderBy:string = "asc";

  constructor(public warehouseService: WarehouseService, public masterService: MasterService, public dialog: MatDialog, public location: Location, public route: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.route.params.subscribe(routeParams => {
      this.shipmentId = routeParams.id;
      
      this.getSummaryDetails();
      this.getSummaryProducts();
    });
  }

  getWarehouses(){
    this.masterService.getIndexGet('/warehouses').subscribe((res) => {
      if (res.data && Array.isArray(res.data)) {
        this.warehouses = res.data;
        // Set default warehouse to first one if available
        if (this.warehouses.length > 0) {
          this.warehouseId = this.warehouses[0].id.toString();
          if (this.shipmentId) {
            this.getSummaryDetails();
            this.getSummaryProducts();
          }
        }
      }
    });
  }

  getSummaryDetails(){
    this.warehouseService.getTransitSummaryDetails(this.warehouseId, this.shipmentId).subscribe(res => {
      if (res.data) {
        this.summaryDetails = res.data;
      }
    });
  }

  getSummaryProducts(page: string = "", search: string = "", expiry: string = ""){
    this.warehouseService.getTransitSummaryProducts(this.warehouseId, this.shipmentId, page, search, expiry).subscribe(res => {
      if (res.data) {
        if (res.data.data.length !== 0) {
          this.totalPages = res.data.last_page;
          this.summaryProducts = res.data.data.map((product: any) => ({
            ...product,
            expanded: false
          }));

          if (this.isSearch || this.isFilter) {
            this.isFilterResult = true;
          }else{
            this.isSummaryProducts = true;
          }
        }else{
          this.totalPages = 0;
          if (this.isSearch || this.isFilter) {
            this.isFilterResult = false;
          }else{
            this.isSummaryProducts = false;
          }
        }
      }
    });
  }

  onAccordionChange(event: any, id: string){
    event.stopPropagation();
    
    // Find the product row
    const productRow = event.target.closest('.product-row');
    if (!productRow) return;

    // Toggle expanded state
    const isExpanded = productRow.classList.contains('expanded');
    productRow.classList.toggle('expanded');

    // Find the product in our data
    const product = this.summaryProducts.find((element: any) => element.id === id);
    if (!product) return;

    // Set expanded state on the product object
    product.expanded = !isExpanded;

    // If expanding and no stock data, fetch it
    if (!isExpanded && product.product_stocks.length === 0) {
      this.warehouseService.getTransitSummaryProductsChildren(this.warehouseId, this.shipmentId, id, this.expirySortValue).subscribe(res => {
        if (res.data) {
          product.product_stocks = res.data;
        }
      });
    }
  }

  onSearchSubmit(){
    if (this.searchInput !== "") {
      this.isSearch = true;
      if (this.isFilter) {
        this.expirySortValue = "";
        this.isFilter = false;
        this.isFilterResult = true;
      }
      this.encodedSearchInput = encodeURIComponent(this.searchInput);
      if (this.currentPage > 1) {
        this.currentPage = 1;
        this.paginationView.onCurrentPageChange(this.currentPage);
      }
      this.getSummaryProducts("", this.encodedSearchInput);
    }
  }

  expirySort(){
    this.isFilter = true;

    if (this.expirySortValue === "asc") {
      this.expirySortValue = "desc";
    }else{
      this.expirySortValue = this.orderBy;
    }

    this.onFilterChange();

  }

  reset(event: Event){
    event.preventDefault();
    if (this.isSearch || this.isFilter) {
      this.encodedSearchInput = "";
      this.expirySortValue = "";
      this.isSearch = false;
      this.isFilter = false;
      this.isFilterResult = true;
      if (this.currentPage > 1) {
        this.currentPage = 1;
        this.paginationView.onCurrentPageChange(this.currentPage);
      }
      this.getSummaryProducts("");
    }
  }

  onFilterChange(){
    if (this.currentPage > 1) {
      this.currentPage = 1;
      this.paginationView.onCurrentPageChange(this.currentPage);
    }
    
    this.getSummaryProducts("", this.encodedSearchInput, this.expirySortValue);
  }

  getQueryPage($event: number){
    this.currentPage = $event;
    this.getSummaryProducts(`${this.currentPage}`, this.encodedSearchInput, this.expirySortValue);
  }

  goBack(){
    this.location.back();
  }
}
